<template>
  <div>
    <transition name="fade" appear><div class="gk-modal-backdrop" v-if="showModal" @click="close"></div></transition>
    <transition name="pop" appear>
      <div class="gk-modal-wrapper" v-if="showModal" :class="wrapperClass">
        <div class="gk-modal" :class="modalClass">
          <slot name="background" />
          <div class="gk-modal-content">
            <slot name="titlebar" />
            <div class="modal-content-wrap" :class="{ 'has-actions': hasActions }">
              <LoadingSpinner v-if="loading" />
              <overlay-scrollbars v-if="overlayScrollb" :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' } }">
                <slot name="maincontent" />
              </overlay-scrollbars>
              <slot v-else name="maincontent" />
            </div>
            <div class="action-buttons-wrapper" :class="{ 'has-actions': hasActions }">
              <slot name="actions" />
            </div>
            <slot name="premiumtip" />
            <GekkoButton 
              v-if="closeable"
              @click="close()"
              icon="fa-solid fa-xmark"
              variant="link"
              size="lg"
              class="close-btn text-unassigned"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import GekkoButton from "@/components/GekkoButton"
export default {
  name: "ModalBase",
  components: {
    LoadingSpinner, GekkoButton
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    autoH: {
      type: Boolean,
      default: false
    },
    fullH: {
      type: Boolean,
      default: false
    },
    fullAutoH: {
      type: Boolean,
      default: false
    },
    narrow: {
      type: Boolean,
      default: false
    },
    widthMd: {
      type: Boolean,
      default: false
    },
    extraNarrow: {
      type: Boolean,
      default: false
    },
    short: {
      type: Boolean,
      default: false
    },
    overlayScrollb: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    onTop: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    hasActions() {
      return !!this.$slots['actions']
    },
    wrapperClass () {
      return [
        (this.onTop) ? 'gk-modal-wrapper-top' : ''
      ]
    },
    modalClass () {
      return [
        (this.short) ? 'gk-modal-h-sm' : '',
        (this.autoH) ? 'gk-modal-h-auto' : '',
        (this.fullH) ? 'gk-modal-h-full' : '',
        (this.fullAutoH) ? 'gk-modal-h-fullauto' : '',
        (this.narrow) ? 'gk-modal-w-sm' : '',
        (this.widthMd) ? 'gk-modal-w-md' : '',
        (this.extraNarrow) ? 'gk-modal-w-xs' : ''
      ]
    }
  },
  created () {
    window.addEventListener('keydown', this.closeEventListener)
  },
  destroyed () {
    window.removeEventListener('keydown', this.closeEventListener)
  },
  methods: {
    closeEventListener (event) {
      if (this.showModal && event.key === 'Escape') this.close()
    },
    close () {
      if (this.closeable) {
        document.body.classList.remove('modal-on')
        this.$emit('close-modal')
      }
    }
  }
};
</script>

<style lang="scss">
  .gk-modal-backdrop {
    height: auto;
    background: rgb(0,0,0,0.3);
    position: fixed;
    top: 0;
    left: 0;
    width: auto;
    z-index: 1005;
    right: 0;
    bottom: 0;
  }
  .gk-modal-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0.5rem;
    z-index: 1010;
    display: flex;
    overflow-y: auto;
    overflow-x: hidden;
    &.gk-modal-wrapper-top {
      bottom: initial;
    }
    @media (min-width: 576px) {
      padding: 1rem;
    }
    .gk-modal {
      background: white;
      margin: auto;
      width: 100%;
      height: 100%;
      overflow: hidden;
      transform: none;
      flex: 1 1 auto;
      padding: 0.5rem;
      box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1),0 8px 10px -6px rgb(0 0 0 / 0.1);
      @media (min-width: 769px) {
        padding: 1rem;
      }
      border-radius: $radiusLg;
      max-width: 1200px;

      position: relative;
      .gk-modal-content {
        position: relative;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        .close-btn {
          position: absolute;
          top: -0.5rem;
          right: -0.5rem;
          cursor: pointer;
          z-index: 9001;
          padding: 0.25rem 1rem;
          @media (min-width: 769px) {
            top: -1rem;
            right: -1rem;
          }
        } 
        .modal-content-wrap {
          flex: 1;
          overflow: visible;
          height: calc(100% - 70px);
          .os-host {
            height: 100%;
          }
          &.has-actions {
            height: calc(100% - 120px);
          }
          .os-host-overflow-y {
            padding-right: 1rem;
          }
        }
      }
      .action-buttons-wrapper {
        z-index: 1;
        &.has-actions {
          padding-top: 1rem;


          // background: #f1f1f1;
          // margin: -1rem;
          // margin-top: 1rem;
          // padding: 1rem;


        }
      }

      .modal-dropzone-actions {
        display: flex;
        flex-direction: column;
        padding-bottom: 1rem;
        &--wrap {
          height: 100%;
          padding: 10px;
          border-radius: $radiusMd;
          background: $inputBackgroundColor;
          box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
          display: block;
        }
        .modal-dropzone-wrapper {
          flex: 1;
          height: 100%;
        }
        .modal-main-actions {
          height: auto;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .hint {
            font-size: 14px;
            padding-left: 10px;
            margin-bottom: -3px;
            line-height: 1.2;
          }
        }
        @media (min-width: 576px) {
          padding-bottom: 0px;
        }
      }


    }
  }

  .modal-on {
    overflow: hidden;
  }

  .gk-modal {
    &.gk-modal-h-auto {
      height: auto !important;
      overflow: visible !important;
    }
    &.gk-modal-h-full {
      display: flex;
      height: auto;
      min-height: 100%;
      .gk-modal-content {
        height: auto;
        flex: 1;
      }
    }
    &.gk-modal-h-fullauto {
      height: auto !important;
      overflow: visible !important;
      max-height: auto !important;
    }

    .gk-modal-label {
      margin-bottom: 0;
      font-size: 12px;
      color: #808080;
    }
    .modal-form-legend {
      margin-top: 20px;
      legend {
        font-size: 16px;
        font-family: DINNextLTPro-Medium, sans-serif;
      }
    }
    .modal-form-legend:first-child {
      margin-top: 0px;
    }
    
  }
</style>

<style lang="scss" scoped>
  .action-button {
    font-size: 14px;
  }
  .gk-modal-w-md {
    max-width: 900px !important;
  }
  .gk-modal-w-sm {
    max-width: 600px !important;
  }
  .gk-modal-w-xs {
    max-width: 420px !important;
  }
  .gk-modal-h-sm {
    max-height: 500px !important;
  }
  .gk-modal-h-fullauto {
    max-height: 100% !important;
  }
</style>
